import { render, staticRenderFns } from "./StatusPending.vue?vue&type=template&id=76f422b1&scoped=true"
import script from "./StatusPending.vue?vue&type=script&lang=js"
export * from "./StatusPending.vue?vue&type=script&lang=js"
import style0 from "./StatusPending.vue?vue&type=style&index=0&id=76f422b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f422b1",
  null
  
)

export default component.exports